import './fonts.css';

export default {
  heading: 'Inter, sans-serif',
  body: 'Inter, sans-serif',
};
